// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__ckG05","formControl":"addForm_formControl__vWFYm","list":"addForm_list__wcGNp","btnWrpper":"addForm_btnWrpper__J6e5Q"};